import { ReactNode } from 'react';
import { UiNotify } from '@frontend/znanie-uikit';
import dynamic from 'next/dynamic';

import { AuthProvider } from 'components/context/AuthContext';

import Layout from 'components/layout/Layout';

import ExitAttempt from 'components/widget/ExitAttempt';

import { usePreserveScroll } from 'hooks/utils/usePreserveScroll';

const PageChangeObserver = dynamic(
  () => import('components/common/PageChangeObserver'),
  {
    ssr: false,
  }
);

const Draft = dynamic(() => import('components/widget/Draft'), {
  ssr: false,
});
const SupportChatBot = dynamic(
  () => import('components/widget/SupportChatBot'),
  { ssr: false }
);
const SearchDesktop = dynamic(
  () => import('components/common/search/SearchDesktop'),
  {
    ssr: false,
  }
);
const SearchMobile = dynamic(
  () => import('components/common/search/SearchMobile'),
  {
    ssr: false,
  }
);

interface IAppContainerProps {
  children: ReactNode;
}

export default function AppContainer({ children }: IAppContainerProps) {
  usePreserveScroll();

  return (
    <AuthProvider>
      <PageChangeObserver />
      <Draft />
      <SupportChatBot />
      <UiNotify />
      <ExitAttempt />
      <SearchDesktop />
      <SearchMobile />
      <Layout>{children}</Layout>
    </AuthProvider>
  );
}
